export class ValidatorList {
    constructor() {
        this.items = new Array();
        this.errors = new Array();
    }
    add(item) {
        this.items.push(item);
    }
    getFieldname() {
        return '';
    }
    isValid() {
        this.items.forEach((item) => {
            item.isValid();
            item.getErrorMessages().forEach((msg) => {
                this.errors.push(msg);
            });
        });
        return this.errors.length == 0;
    }
    getErrorMessages() {
        return this.errors;
    }
}
//# sourceMappingURL=validatorList.js.map